<template>
  <div>
    <EditorSingleComment
      v-for="(comment, i) in assignmentComments"
      :key="`comment-${i}`"
      :comment="comment"
    />
  </div>
</template>

<script>
// vuex
import { mapGetters } from "vuex";
// components
import EditorSingleComment from "./EditorSingleComment.vue";

export default {
  name: "EditorExistingComments",
  components: {
    EditorSingleComment,
  },
  computed: {
    ...mapGetters("editor", ["assignmentComments"]),
  },
};
</script>

<style lang="scss" scoped></style>
